import type { SVGProps } from 'react';

import { cn } from '../../lib/cn';

type FlagProps = Omit<SVGProps<SVGSVGElement>, 'viewBox' | 'children'>;

/** Drapeaux en SVG (ratio 3:2), couleurs officielles. */
function Flag({ className, children, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 3 2"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={cn('h-3.5 w-5 shrink-0 rounded-[2px] ring-1 ring-black/10', className)}
      {...props}
    >
      {children}
    </svg>
  );
}

export function FlagFR(props: FlagProps) {
  return (
    <Flag {...props}>
      <rect width="1" height="2" fill="#002654" />
      <rect x="1" width="1" height="2" fill="#FFFFFF" />
      <rect x="2" width="1" height="2" fill="#ED2939" />
    </Flag>
  );
}

export function FlagDE(props: FlagProps) {
  return (
    <Flag {...props}>
      <rect width="3" height="0.667" fill="#000000" />
      <rect y="0.667" width="3" height="0.666" fill="#DD0000" />
      <rect y="1.333" width="3" height="0.667" fill="#FFCE00" />
    </Flag>
  );
}

export function FlagIT(props: FlagProps) {
  return (
    <Flag {...props}>
      <rect width="1" height="2" fill="#008C45" />
      <rect x="1" width="1" height="2" fill="#F4F5F0" />
      <rect x="2" width="1" height="2" fill="#CD212A" />
    </Flag>
  );
}

export function FlagNL(props: FlagProps) {
  return (
    <Flag {...props}>
      <rect width="3" height="0.667" fill="#AE1C28" />
      <rect y="0.667" width="3" height="0.666" fill="#FFFFFF" />
      <rect y="1.333" width="3" height="0.667" fill="#21468B" />
    </Flag>
  );
}

export function FlagMC(props: FlagProps) {
  return (
    <Flag {...props}>
      <rect width="3" height="1" fill="#CE1126" />
      <rect y="1" width="3" height="1" fill="#FFFFFF" />
    </Flag>
  );
}
